import type { BillAccount } from '@amfam/shared/models/lib/billing/bill-account.model';

export interface BillAccountCanRegister {
  billAccountNumber: string | null;
  policyNumber: string | null;
  billingAccount: BillAccount | null;
  loading: boolean;
  loaded: boolean;
  canRegister: boolean | null;
  status: unknown;
}

export const initialBillAccountCanRegister: BillAccountCanRegister = {
  billAccountNumber: null,
  policyNumber: null,
  billingAccount: null,
  loading: false,
  loaded: false,
  canRegister: null,
  status: null
};
